// Helper to apply meta tags dynamically
export const updateMetaTags = (config = {}) => {
  if (typeof document === "undefined") return;
  const { title, description, keywords, image } = config;

  if (title) document.title = title;

  const setTag = (selector, attr, value) => {
    const el = document.querySelector(selector);
    if (el && value) el.setAttribute(attr, value);
  };

  // Basic description/keywords
  setTag('meta[name="description"]', 'content', description || '');
  setTag('meta[name="keywords"]', 'content', keywords || '');

  // Open Graph / Twitter
  setTag('meta[property="og:title"]', 'content', title || '');
  setTag('meta[property="og:description"]', 'content', description || '');
  setTag('meta[property="og:image"]', 'content', image || 'socialpreview.png');
  setTag('meta[name="twitter:title"]', 'content', title || '');
  setTag('meta[name="twitter:description"]', 'content', description || '');
  setTag('meta[name="twitter:image"]', 'content', image || 'socialpreview.png');
};

export default updateMetaTags;